import { render, staticRenderFns } from "./Escalacao.vue?vue&type=template&id=14ee4f4e&scoped=true"
import script from "./Escalacao.vue?vue&type=script&lang=js"
export * from "./Escalacao.vue?vue&type=script&lang=js"
import style0 from "./Escalacao.vue?vue&type=style&index=0&id=14ee4f4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ee4f4e",
  null
  
)

export default component.exports